module.exports = __webpack_public_path__ + "img/06_Underpurlins.37226067.png";